module.exports = __webpack_public_path__ + "static/media/total-revenue.209549f9.png";